import { TextButton } from '@wix/design-system';
import { contactSupportUrl, dataHooks } from '../../utils/constants';
import useMarketplaceHeaderBi, {
  BI_CLICK_DATA,
  BI_CLICK_TYPES,
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';

interface MenuLinkProps {
  pageName: IMPHeaderPageName;
  title: string;
}
const ContactSupportLink = ({ pageName, title }: MenuLinkProps) => {
  const { reportClick } = useMarketplaceHeaderBi({ pageName });

  return (
    <TextButton
      dataHook={dataHooks.contactSupportLink}
      as="a"
      weight="normal"
      skin="dark"
      href={contactSupportUrl}
      onClick={() => {
        reportClick({
          clickType: BI_CLICK_TYPES.profileDropdownMenu,
          clickData: BI_CLICK_DATA.contactSupport,
        });
      }}
    >
      {title}
    </TextButton>
  );
};

export default ContactSupportLink;
